"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useEnterUpCallback = exports.useEnterDownCallback = exports.handleEnterDown = void 0;
var _react = require("react");
/**
 * function to handle the Enter key press action
 * @param {Object} e;
 * @param {Function} action;
 */
var handleEnterDown = exports.handleEnterDown = function handleEnterDown(e, action) {
  if (e.key === 'Enter') {
    action();
  }
};
var useEnterUpCallback = exports.useEnterUpCallback = function useEnterUpCallback(onConfirm) {
  return (0, _react.useCallback)(function (e) {
    return handleEnterDown(e, function () {
      return onConfirm(true);
    });
  }, [handleEnterDown, onConfirm]);
};
var useEnterDownCallback = exports.useEnterDownCallback = function useEnterDownCallback(onConfirm) {
  return (0, _react.useCallback)(function (e) {
    return handleEnterDown(e, function () {
      return onConfirm(false);
    });
  }, [handleEnterDown, onConfirm]);
};